import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { CheckboxItemType } from '../form';
import { SecondaryButton, TertiaryButton } from '../button';
import { RefineList } from './RefineList';

export type RefineProps = {
  defaultSelectedOptions?: string[];
  onSubmit: (selectedOptions: string[]) => void;
  options: CheckboxItemType[];
  title: string;
};

const Wrapper = styled.div`
  background-color: ${theme.colors.primary.white};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  box-sizing: border-box;
  margin-top: ${theme.spacings[4].rem};
  padding: ${theme.spacings[4].rem};
  position: absolute;
  width: 100%;
  width: -webkit-fill-available;
  width: -moz-available;
`;

const Title = styled.label`
  display: block;
  font-family: ${theme.fonts.roboto};
  font-size: ${theme.typography.body.md['font-size']};
  font-weight: 700;
  line-height: ${theme.typography.body.md['line-height']};
  margin-bottom: ${theme.spacings[4].rem};
`;

const SubmitWrapper = styled.span`
  display: inline-block;
  margin: ${theme.spacings[2].rem} ${theme.spacings[4].rem} 0 0;
`;

export const Refine: React.FC<RefineProps> = ({
  defaultSelectedOptions = [],
  onSubmit,
  options,
  title,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  useEffect(() => {
    if (defaultSelectedOptions.length > 0) {
      setSelectedOptions(defaultSelectedOptions);
    }
  }, [defaultSelectedOptions]);

  const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    const option = event.target.name;

    if (checked) {
      setSelectedOptions([...selectedOptions, option]);
    } else if (selectedOptions.includes(option)) {
      setSelectedOptions(
        selectedOptions.filter((updated) => updated !== option)
      );
    }
  };

  const handleSubmit = () => {
    onSubmit(selectedOptions);
  };

  const handleClear = () => {
    setSelectedOptions([]);
    onSubmit([]);
  };

  return (
    <Wrapper>
      <Title>{title}</Title>

      <RefineList
        options={options}
        selectedOptions={selectedOptions}
        handleSelect={handleSelect}
      />

      <SubmitWrapper>
        <SecondaryButton fullWidth={false} onClick={handleSubmit} size="small">
          Apply filters
        </SecondaryButton>
      </SubmitWrapper>

      <TertiaryButton fullWidth={false} onClick={handleClear} size="small">
        Clear filters
      </TertiaryButton>
    </Wrapper>
  );
};
